import { useEffect, useState } from 'react';
import useSWR from 'swr';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import { generateApiPath, getCollectionPaginated } from '#app/Handler/api';
import useCheckOpening from '#app/View/Shop/hooks/useCheckOpening';
import ClientEntryPoints from '#app/entrypoints/client';
import { Collection } from '#app/typings/api';
import { ClientList } from '#app/typings/client';

const MAX_RESULT = 10;

type HookReturn = {
  clients: ClientList[];
  loading: boolean;
  setFilters: (filters: Filters) => void;
};

export type Filters = {
  number?: string;
  email?: string;
  firstname?: string;
  lastname?: string;
  zipCode?: string;
  phone?: string;
};

const useClientList = (): HookReturn => {
  useCheckOpening(true);
  const [filters, setFilters] = useState<Filters>({});
  const { data: clients, isLoading } = useSWR<Collection<ClientList>>(
    Object.values(filters).some((value) => !!value)
      ? generateApiPath(ClientEntryPoints.getCollectionForShop, {}, filters)
      : null,
    getCollectionPaginated,
    { revalidateOnFocus: false },
  );

  useEffect(() => {
    if (clients?.totalItems && clients.totalItems > MAX_RESULT) {
      dispatch(
        SnackbarOpen({
          text: `Nombre de résultats > ${MAX_RESULT}, merci de remplir d'autres critères de recherche.`,
          variant: 'error',
        }),
      );
    }
  }, [clients]);

  return {
    clients: clients?.totalItems && clients.totalItems > MAX_RESULT ? [] : (clients?.data ?? []),
    loading: isLoading,
    setFilters: (filters) => setFilters(filters),
  };
};

export default useClientList;
